<span class="round" 
      [ngStyle]="{'height': width + 'px', 'width': width + 'px'}" 
      style="margin: 2px;">
    <div class="image-container">
        <img [src]="src" onError="this.src='assets/images/noimage.png'">
    </div>
</span>
